<template>
  <CRow>
    <CCol sm="12">
      <CrmReports
        title="CRM Reports"
        standalone
        group-by-day
        show-link-filter
        show-user-filter
      />
    </CCol>
  </CRow>
</template>

<script>
import CrmReports from "./CrmReports";

export default {
  name: "CrmReportList",
  components: {
    CrmReports,
  },
};
</script>
